module.exports = __webpack_public_path__ + "img/address.f2713b0b.png";